const DOT_DECIMAL_PATTERN: RegExp = /^\d+\.\d{1,2}$/;

export function trimmedOrUndefined(typed: string): string | undefined {
  return typed.trim() || undefined;
}

export function normalizeAmount(typed: string): string | undefined {
  const text: string = typed.trim();
  const plain: string = DOT_DECIMAL_PATTERN.test(text)
    ? text
    : text.replace(/\./g, "").replace(",", ".");
  const amount: number = Number(plain);
  if (plain === "" || !Number.isFinite(amount)) return undefined;
  return String(amount);
}
